//@flow

import type {ClearancePrice} from "./clearanceTypes";


export  async function fetchClearanceProductPrices(productCodes:number[] ): Promise<{ [productId: number]: ClearancePrice }> {
    return await ( await fetch(`/search/products/clearance/prices/batch?productCodes=${productCodes.join(
        ","
    )}`, {
        credentials: "include",
    })).json();

}





// WEBPACK FOOTER //
// ./javascript/product-search-page/clearance/fetchClearanceProducts.js